import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import MgcWrapper from '../MgcWrapper';
import ScopeWrapper from '../ScopeWrapper';
import StrategyOverviewWrapper from '../StrategyOverviewWrapper';
import { useUserInfo } from '../../shared/UserInfo';
import DuplicateStrategyAlert from '../../shared/DuplicateStrategyAlert';
import { paintSaveAndNextButton } from '../../shared/UtilFunctions';

export default function DefineStrategy(props) {
  const { commonProps, strategyProps, strategyInformation, showSaveButton } =
    props;
  const info = useUserInfo();
  const isAdmin = info && info.isAdmin;
  const isSBM = info && info.isSBM;
  const isCommMgr = info && info.isCommMgr;
  const hasDuplicateStrategies =
    strategyProps.duplicateStrategyList &&
    strategyProps.duplicateStrategyList.length > 0;
  const duplicateStrategyState = hasDuplicateStrategies
    ? strategyProps.okToPublish
    : null;

  return (
    <Box
      sx={(theme) => ({
        mb: theme.fuel6Tokens.JddcSpacingMedium
      })}
    >
      <Grid container alignItems="flex-start" spacing={2}>
        {hasDuplicateStrategies && (
          <Grid size={11}>
            <DuplicateStrategyAlert
              okToPublish={strategyProps.okToPublish}
              duplicateStrategyList={strategyProps.duplicateStrategyList}
              strategyInformation={strategyInformation}
              commonProps={commonProps}
            />
          </Grid>
        )}

        <Grid size={5.5}>
          <MgcWrapper
            strategyInformation={strategyInformation}
            masterMGCJson={strategyProps.masterMGCJson}
            setParentMgcData={strategyProps.setParentMgcData}
            selectedMgc={strategyProps.selectedMgc}
            selectedMGCList={strategyProps.selectedMGCList}
            isEditable={commonProps.isEdit}
            selectedMgcAfterEdit={strategyProps.selectedMgcAfterEdit}
            resetSelectedMgcAfterEdit={strategyProps.resetSelectedMgcAfterEdit}
            label="Material Group Code"
            saveMgcError={strategyProps.saveMgcError}
            register={commonProps.register}
            selectedMgcsUpdated={strategyProps.selectedMgcsUpdated}
            commonProps={commonProps}
            duplicateStrategyState={duplicateStrategyState}
            isNewForm={true}
          />

          {strategyProps.owners && strategyProps.approvers && (
            <StrategyOverviewWrapper
              ownerObj={strategyProps.ownerObj}
              ownerDefaultValue={(isAdmin || isSBM) && strategyProps.ownerObj}
              masterOwnerUserList={
                strategyProps.owners ? strategyProps.owners : []
              }
              masterApproverUserList={
                strategyProps.approvers ? strategyProps.approvers : []
              }
              approverDefaultValue={
                (isAdmin || isCommMgr) && strategyProps.ownerObj
              }
              readOnly={strategyProps.readOnly}
              isNewForm={true}
              strategyInformation={strategyInformation}
              commonProps={commonProps}
              userInfoMap={strategyProps.userInfoMap}
              selectedOverviewViewList={strategyProps.selectedOverviewViewList}
              setSelectedOverviewViewList={
                strategyProps.setSelectedOverviewViewList
              }
              forCreate={commonProps.strategyNumber === 0}
            />
          )}
        </Grid>

        <Grid size={5.5}>
          <ScopeWrapper
            strategyInformation={strategyInformation}
            isEdit={commonProps.isEdit}
            masterScopeJson={strategyProps.masterScopeJson}
            register={commonProps.register}
            commonProps={commonProps}
            selectedScopeUnits={strategyProps.selectedScopeUnits}
            strategyNumber={commonProps.strategyNumber}
            scopeType={strategyProps.scopeType}
            missingScopeError={strategyProps.missingScopeError}
            selectedScopeViewList={strategyProps.selectedScopeViewList}
            okToPublish={strategyProps.okToPublish}
            duplicateStrategyState={duplicateStrategyState}
            isNewForm={true}
          />
        </Grid>
      </Grid>

      {paintSaveAndNextButton(showSaveButton)}
    </Box>
  );
}
